import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import RatingComponent from '../ratings/RatingComponent'
import ReviewCardComponent from '../cards/ReviewCardComponent'
import styles from './ReviewSectionComponent.module.scss'
import { Reviews } from 'state/ducks/space/models'

interface Props {
  averageReviewRating: number
  reviewsCount: number
  reviews: Array<Reviews>
}

const ReviewSectionComponent: FC<Props> = ({
  averageReviewRating,
  reviewsCount,
  reviews,
}: Props): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className={styles.reviewSection}>
      <section className={styles.reviewSectionContents}>
        <div className={styles.reviewSectionContentsHeading}>
          <div className={styles.heading}>
            <h2 className={styles.headingTitle}>{t('COMMON.REVIEW_LABEL')}</h2>
            <div className={styles.review}>
              <div className={styles.reviewRatingAverage}>{averageReviewRating}</div>
              <div className={styles.reviewRating}>
                <RatingComponent averageRating={averageReviewRating} />
              </div>
              <div className={styles.reviewCount}>{reviewsCount}</div>
            </div>
          </div>
        </div>
        <ul className={styles.reviewsPost}>
          {(reviews || []).map((review, index) => (
            <ReviewCardComponent
              review={review}
              key={index}
              listItemClassName={styles.reviewsPostItem}
            />
          ))}
        </ul>
      </section>
    </div>
  )
}

export default ReviewSectionComponent
